import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { BadgeDollarSign, Leaf, ShoppingBag, Sparkles } from 'lucide-react';

function AboutSmartInventoryTab({ t, onOpenOnboarding }) {
  const keywords = t('about.keywords');

  return (
    <div className="grid gap-6">
      <Card className="overflow-hidden border-0 bg-gradient-to-br from-cyan-50 via-white to-emerald-50 shadow-xl">
        <CardContent className="grid gap-6 p-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
          <div>
            <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-cyan-700">
              <Sparkles className="h-4 w-4" />
              {t('about.badge')}
            </div>
            <h2 className="text-3xl font-bold text-gray-900">{t('about.title')}</h2>
            <div className="mt-3 inline-flex items-center rounded-full bg-gray-900 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-white">
              Version V1.0.29
            </div>
            <p className="mt-3 text-base leading-7 text-gray-700">{t('about.description')}</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {Array.isArray(keywords)
                ? keywords.map((keyword) => (
                    <Badge key={keyword} className="bg-cyan-100 text-cyan-800">
                      {keyword}
                    </Badge>
                  ))
                : null}
            </div>
          </div>
          <div className="rounded-3xl bg-gray-950 p-6 text-white shadow-2xl">
            <p className="text-sm uppercase tracking-[0.18em] text-emerald-300">{t('about.valueCardTitle')}</p>
            <p className="mt-4 text-2xl font-semibold leading-tight">{t('about.valueCardText')}</p>
            <Button onClick={onOpenOnboarding} className="mt-6 bg-white text-gray-900 hover:bg-gray-100">
              {t('about.openOnboarding')}
            </Button>
          </div>
        </CardContent>
      </Card>

      <div className="grid gap-4 lg:grid-cols-3">
        <Card className="shadow-lg">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-gray-900">
              <ShoppingBag className="h-5 w-5 text-orange-600" />
              {t('about.cards.smartShoppingTitle')}
            </CardTitle>
            <CardDescription>{t('about.cards.smartShoppingDescription')}</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm leading-6 text-gray-700">{t('about.cards.smartShoppingText')}</p>
          </CardContent>
        </Card>

        <Card className="shadow-lg">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-gray-900">
              <BadgeDollarSign className="h-5 w-5 text-emerald-600" />
              {t('about.cards.budgetTitle')}
            </CardTitle>
            <CardDescription>{t('about.cards.budgetDescription')}</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm leading-6 text-gray-700">{t('about.cards.budgetText')}</p>
          </CardContent>
        </Card>

        <Card className="shadow-lg">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-gray-900">
              <Leaf className="h-5 w-5 text-lime-600" />
              {t('about.cards.responsibleTitle')}
            </CardTitle>
            <CardDescription>{t('about.cards.responsibleDescription')}</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm leading-6 text-gray-700">{t('about.cards.responsibleText')}</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default AboutSmartInventoryTab;